import type { AnchorButtonProps } from '@blueprintjs/core';
import { AnchorButton } from '@blueprintjs/core';
import * as React from 'react';

import { history } from 'vms/app/configureApp';

type Props = Omit<AnchorButtonProps, 'onClick'> & { to: string };

const AppAnchorButton = (props: Props) => (
  <AnchorButton {...props} onClick={() => history.push(props.to)} />
);

export default AppAnchorButton;
